// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"87a65d38","115":"a215cfcd","331":"5d6028c6","444":"f989b2f1","470":"b7e0b0f3","609":"39a779a5","796":"7f984e4a","818":"3a57bfa9"}[chunkId] + ".chunk.css";
};